/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import Link from '@material-ui/core/Link';
import type {Crumb} from '@ion/core/src/types/entities';

/**
 * @defineBreadcrumbs
 *
 * Provides a utility which allows to define the breadcrumbs
 *
 * ```typescript
 *    import React from 'react';
 *    import {defineBreadcrumbs} from '@ion/dls/src/components/breadcrumbs/BreadcrumbUtils';
 *
 *    defineBreadcrumbs({crumbs, classes, handleCrumbClick});
 * ```
 */
export const defineBreadcrumbs = ({
  crumbs,
  classes,
  allCrumbsClickable = false
}): Crumb[] => {
  const display = [];
  crumbs.map((crumb, index) => {
    display.push(
      <Link key={`crumb-${index}`} style={{textDecoration: 'none'}}
        className={(crumbs.length - 1) === index
          ? classes.activeCrumb : classes.inactiveCrumb}
        onClick={crumb.click ? function() {
          if (index !== crumbs.length - 1 || allCrumbsClickable) crumb.onClick();
        } : undefined}>
        {crumb.label}
      </Link>);
  });
  return display;
};
